<template>
  <div v-if="isMounted">
    <div
      class="home"
      v-if="
        store.state.token &&
        router.currentRoute.value.path != '/login' &&
        router.currentRoute.value.path != '/404' &&
        router.currentRoute.value.path != '/notAuthority'
      "
      :style="
        router.currentRoute.value.path == '/'
          ? ''
          : { height: store.state.windowHeight + 'px' }
      "
    >
      <indexComponent
        :navList="navList"
        :allNavList="allNavList"
        v-if="navList.length > 0"
        @getTree="getTree"
      />
    </div>
    <div class="index" v-else>
      <router-view />
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, watch, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  adminUserGetUserInfo,
  adminGameManagePlatform,
  adminUserMenuTree,
} from "@/apis/api";
import { getStorage, setStorage, removeStorage } from "@/utils/storage";
import indexComponent from "@/components/index.vue";
import i18n from "@/lang";
const { t } = i18n.global;
export default {
  components: {
    indexComponent,
  },
  setup(props) {
    const isMounted = ref(false);
    const store = useStore();
    const processEnv = reactive(process.env);
    //设置语言
    const language = getStorage("language") || "zh";
    store.commit("SET_LANG", language);
    //浏览器宽高监听
    store.commit("SET_WINDOWWIDTH", window.innerWidth);
    store.commit("SET_WINDOWHEIGHT", window.innerHeight);
    window.onresize = () => {
      store.commit("SET_WINDOWWIDTH", window.innerWidth);
      store.commit("SET_WINDOWHEIGHT", window.innerHeight);
    };
    const router = useRouter();
    const state = reactive({
      navList: [],
      allNavList: [],
    });
    watch(
      () => store.state.token,
      (newVal) => {
        if (newVal) {
          getTree();
        }
      }
    );
    //关闭浏览器的同时删除用户登录信息
    // onUnmounted(() => {
    //   if (processEnv && processEnv.NODE_ENV != "development") {
    //     removeStorage({ name: "token" });
    //   }
    // });
    //判断是否登陆
    let token = getStorage("token");
    if (!getStorage("error")) {
      if (token) {
        //请求用户信息
        adminUserGetUserInfo().then((res) => {
          store.commit("SET_USERINFO", res.data.user);
          store.commit("SET_TOKEN", token);
          //获取所属平台
          adminGameManagePlatform().then((res) => {
            store.commit("SET_PLATFORMLIST", res.data);
            isMounted.value = true;
          });
          if (router.currentRoute.value.path == "/login") {
            router.push({
              path: "/",
            });
          }
        });
      } else {
        state.navList = null;
        isMounted.value = true;
        router.push({
          path: "/login",
        });
      }
    } else {
      router.push({
        path: "/notAuthority",
      });
      isMounted.value = true;
    }
    const getTree = () => {
      //权限树
      state.navList = [];
      adminUserMenuTree().then((res) => {
        let data = res.data;
        if (data && data.constructor === Array && data.length > 0) {
          //剔除掉home
          let homeIndex = null;
          data.map((item, index) => {
            if (item.code == "home") {
              homeIndex = index;
            }
          });
          if (homeIndex || homeIndex === 0) {
            store.commit("SET_HOMEMENU", data[homeIndex]);
            data.splice(homeIndex, 1);
          }
          data.map((item, index) => {
            item["index"] = index + "";
            if (
              item.child &&
              item.child.length > 0 &&
              item.child[0]["category"] == 1
            ) {
              item.child.map((item1, index1) => {
                item1["index"] = index + "-" + index1;
                if (
                  item1.child &&
                  item1.child.length > 0 &&
                  item1.child[0]["category"] == 1
                ) {
                  item1.child.map((item2, index2) => {
                    item2["index"] = index + "-" + index1 + "-" + index2;
                  });
                }
              });
            }
          });
          state.navList = data;
        }
        state.navList.push({
          name: t("commonNav2"),
          isHide: true,
          code: "other",
          child: [
            {
              name: t("commonNav1"),
              path: "/mine/mineUserInfo",
              code: "mineUserInfo",
            },
          ],
        });
        //获取所有子路由
        let currentPagePower = ref(false); //是否有当前页面的访问权限（第一次访问项目router.before会比请求权限优先执行，需手动调整路由）
        state.navList.map((item) => {
          item.child &&
            item.child.map((item1) => {
              if (item1.child && item1.child[0]["category"] == 1) {
                item1.child.map((item2) => {
                  state.allNavList.push(item2);
                  if (router.currentRoute.value.path == item2.path) {
                    currentPagePower.value = true;
                  }
                });
              } else {
                state.allNavList.push(item1);
                if (router.currentRoute.value.path == item1.path) {
                  currentPagePower.value = true;
                }
              }
            });
        });
        setStorage({ name: "allNavList", content: state.allNavList });
        if (
          !currentPagePower.value &&
          router.currentRoute.value.path != "/login" &&
          router.currentRoute.value.path != "/404" &&
          router.currentRoute.value.path != "/notAuthority" &&
          router.currentRoute.value.path != "/"
        ) {
          router.push({
            path: "/404",
          });
        }
        if (store.state.platformList) {
          isMounted.value = true;
        }
      });
    };
    return {
      store,
      isMounted,
      router,
      ...toRefs(state),
      getTree,
    };
  },
};
</script>
<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.home {
  display: flex;
  justify-content: flex-start;
  background: #f0f2f5;
  .nav {
    .iconfont {
      display: inline-block;
      margin-right: 5px;
    }
  }
  .content {
    .box {
      position: relative;
      margin-top: 65px;
      .more {
        position: absolute;
        right: 20px;
        z-index: 10;
        top: 7px;
      }
      .home-install {
        position: absolute;
        width: 70px;
        height: 40px;
        z-index: 3;
        cursor: pointer;
      }
      :deep(.el-tabs__header) {
        background: #fff !important;
        padding-right: 100px;
        margin-bottom: 10px;
      }
      :deep(.el-tabs__item.is-active) {
        color: #f6ca9d;
      }
      :deep(.el-tabs__item:hover) {
        color: #f6ca9d;
      }
      :deep(.el-tabs__content) {
        margin: 0px 10px;
      }
    }
  }
}
</style>
